module.exports = __webpack_public_path__ + "static/media/shaff1172.63b2c904.jpg";